import { api } from "./http-client";
import { API_PATHS } from "../config/api.config";
import {
  AuthResult,
  LoginResult,
  OtpPurpose,
  User,
} from "../interfaces/user.interface";

export interface RegisterPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const authService = {
  /** Creates NO account — returns a tempToken to hand to verifyOtp. */
  register: async (payload: RegisterPayload): Promise<{ tempToken: string }> =>
    (
      await api.request<{ tempToken: string }>({
        url: API_PATHS.AUTH.REGISTER,
        method: "POST",
        data: payload,
      })
    ).data,

  /** Sets the auth cookies; for "register" it also creates the account. */
  verifyOtp: async (
    tempToken: string,
    otp: string,
    purpose: OtpPurpose = "register",
  ): Promise<AuthResult> =>
    (
      await api.request<AuthResult>({
        url: API_PATHS.AUTH.VERIFY_OTP,
        method: "POST",
        data: { tempToken, otp, purpose },
      })
    ).data,

  resendOtp: async (
    tempToken: string,
    purpose: OtpPurpose = "register",
  ): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.RESEND_OTP,
      method: "POST",
      data: { tempToken, purpose },
    });
  },

  login: async (email: string, password: string): Promise<LoginResult> =>
    (
      await api.request<LoginResult>({
        url: API_PATHS.AUTH.LOGIN,
        method: "POST",
        data: { email, password },
      })
    ).data,

  forgotPassword: async (email: string): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.FORGOT_PASSWORD,
      method: "POST",
      data: { email },
    });
  },

  resetPassword: async (
    email: string,
    otp: string,
    newPassword: string,
  ): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.RESET_PASSWORD,
      method: "POST",
      data: { email, otp, newPassword },
    });
  },

  logout: async (): Promise<void> => {
    await api.request({ url: API_PATHS.AUTH.LOGOUT, method: "POST" });
  },

  getProfile: async (): Promise<User> =>
    (await api.request<User>({ url: API_PATHS.AUTH.PROFILE, method: "GET" }))
      .data,
};
